"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["children", "className", "width", "dropMargins", "narrowYMargins", "dropYMargins", "dropMobileXMargins", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@autoguru/overdrive';
import { invariant } from '@autoguru/utilities';
import * as styles from './ContainedLayout.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContainedLayout = _ref => {
  let {
      children,
      className = '',
      width = 'medium',
      dropMargins = false,
      narrowYMargins = false,
      dropYMargins = false,
      dropMobileXMargins = false,
      as = 'section'
    } = _ref,
    boxProps = _objectWithoutProperties(_ref, _excluded);
  !!(dropYMargins && narrowYMargins) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Both dropYMargins & narrowYMargins cannot be true at the same time') : invariant(false) : void 0;
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, boxProps), {}, {
    as: as,
    width: "full",
    className: [styles.root, className, {
      [styles.narrow]: width === 'narrow',
      [styles.wide]: width === 'wide',
      [styles.extraWide]: width === 'extra-wide',
      [styles.bleed]: width === 'bleed'
    }],
    children: /*#__PURE__*/_jsx(Box, {
      width: "full",
      className: [styles.contents, {
        [styles.withYMargins]: !dropYMargins && !dropMargins,
        [styles.withoutYMargins]: dropYMargins,
        [styles.withNarrowYMargins]: narrowYMargins,
        [styles.withMobileXMargins]: !dropMobileXMargins && !dropMargins,
        [styles.withoutMobileXMargins]: dropMobileXMargins,
        [styles.withoutMargins]: dropMargins
      }],
      children: /*#__PURE__*/_jsx(Box, {
        width: "full",
        className: styles.childHolder,
        children: children
      })
    })
  }));
};